/* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }] */
const mod11OfNumberWithControlDigit = (input: any): number => {
    let controlNumber = 2;
    let sumForMod = 0;
    let i;

    for (i = input.length - 2; i >= 0; --i) {
        sumForMod += input.charAt(i) * controlNumber;
        controlNumber += 1;
        if (controlNumber > 7) {
            controlNumber = 2;
        }
    }
    const result = 11 - (sumForMod % 11);

    return result === 11 ? 0 : result;
};

export const validateAccountNumber = (accountNumber: string | number): boolean => {
    if (!accountNumber) {
        return false;
    }
    accountNumber = accountNumber.toString().replace(/\./g, '');
    if (accountNumber.length !== 11) {
        return false;
    }
    return (
        parseInt(accountNumber.charAt(accountNumber.length - 1), 10) === mod11OfNumberWithControlDigit(accountNumber)
    );
};

export const undefinedOrNull = (value: string | number): boolean => {
    return value === undefined || value === null;
};

export const stripAnyNonNumericCharacters = (value: string | number): string => {
    if (!value) {
        value = '';
    } else if (typeof value !== 'string') {
        value = value.toString();
    }
    return value.replace(/\D/g, '');
};

// 0 <= value < 1.000.000.000
export const containsUint = (value: string | number): boolean => {
    const number = stripAnyNonNumericCharacters(value);
    if (Number.isInteger(parseInt(number, 10))) {
        const parsedNumber = parseInt(number, 10);
        return parsedNumber >= 0 && parsedNumber < 1000000000;
    }
    return false;
};

// returns numbers in value or ''
export const asIntString = (value: string | number): string => {
    const number = stripAnyNonNumericCharacters(value);
    if (!number) return '';
    return parseInt(number, 10).toString();
};

export const validateAdjacentCiphers = (pin: string): boolean => {
    return !new RegExp('(012|123|234|345|456|567|678|789|890|901|098|987|876|765|654|543|432|321|210|109)').test(pin);
};

export const validateRecurringCiphers = (pin: string): boolean => {
    const freq: any = {};
    return undefinedOrNull(
        pin
            .split('')
            .map((c) => {
                freq[c] = freq[c] ? freq[c] + 1 : 1;
                return freq[c];
            })

            .find((e) => e > 2),
    );
};

export const isValidPin = (pin: string): boolean => {
    return !!pin && pin.length === 4 && validateRecurringCiphers(pin) && validateAdjacentCiphers(pin);
};
